import { WithPermissions } from 'react-admin';
import { ReactElement, ReactNode } from 'react';
import { Permission, PermissionData } from 'src/pages/admin/entities/permission.entity';

interface PermissionButtonProps {
    resource: string;
    action: string;
    children: ReactNode;
}

export const PermissionButton = ({ resource, action, children }: PermissionButtonProps): ReactElement => {
    return (
        <WithPermissions
            render={({ permissions }): ReactElement => {

                // WithPermissions renders optimistically: `permissions` is undefined until getPermissions()
                // resolves, so read it defensively and stay hidden until we know the user is allowed.
                const data = permissions as PermissionData | undefined;
                const permissionList = data?.permissions || [];

                const allowed = permissionList.some(
                    (perm: Permission) =>
                        (perm.resource === resource || perm.resource === '*') &&
                        (perm.action.includes(action) || perm.action.includes('*'))
                );

                return allowed ? <>{children}</> : <></>;
            }}
        />
    );
};
